<template>
  <div class="row">
      <div class="col-md-12 col-xxl-12 col-sm-12 mb-10">
        <div class="card mb-25 border-0 rounded-0">
          <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
            <div class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25">
              <h4 class="position-relative text-black fw-bold mb-10">Informations générales</h4>
              <router-link to="/livraisons/liste-livraisons" 
              class=" btn btn-primary transition border-0 lh-1 fw-medium">
              <i class="flaticon-left-arrow  lh-1 me-1 position-relative top-2"></i>
              <span class="position-relative"></span>Retour</router-link>
            </div>
         
          <div class="row mb-4">
            <div class="col-md-3">
              <label class="text-muted">Date</label>
              <p class="fw-semibold">{{ format_Date(livraison?.dateLiv) }}</p>
            </div>
            <div class="col-md-3">
              <label class="text-muted">Commande</label>
              <p class="fw-semibold">{{ livraison?.commandeClient?.refCom || 'N/A' }}</p>
            </div>
            <!-- <div class="col-md-3">
              <label class="text-muted">Liveur</label>
              <p class="fw-semibold">{{ livraison?.commandeClient?.client?.nomClient || 'N/A' }}</p>
            </div>
            <div class="col-md-3">
              <label class="text-muted">Adresse de livraison</label>
              <p class="fw-semibold">{{ livraison?.adresselivraison?.adresse || 'N/A' }}</p>
            </div> -->
          </div>

          <h5 class="fw-semibold text-primary mb-3">Produits livrés</h5>
          <div class="table-responsive">
            <table class="table table-bordered table-hover">
              <thead class="table-light">
                <tr>
                  <th>Produit commandé</th>
                  <th>Quantité livrée</th>
                  <th>Quantité restante à livrer</th>
                  <th>Magasin</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(livr, index) in livraison?.procondimaglivraisons" :key="index">
                  <td>{{ livr.proCondiCommandeClient?.produitConditionnement?.nomProCond }}</td>
                  <td>{{ livr.qtite }}</td>
                  <td>{{ livr.qtiteRestanteCommande ?? 'N/A' }}</td>
                  <td>{{ livr.magasin?.nomMagasin }}</td>
                </tr>
              </tbody>
            </table>
          </div>

          </div>
        </div>
      </div>
  </div>

</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from "vue";
import ApiService from "@/services/ApiService";
import { Societe } from "@/models/Societe";
import { error, format_Date, showModal } from "@/utils/utils";
import { useRoute } from "vue-router";
import { Livraison } from "@/models/Livraison";

export default defineComponent({
  name: "ViewLivraison",
  setup: () => {
    const route = useRoute();
    const livraison = ref<Livraison | null>(null);

    function getLivraison(id: string) {
      return ApiService.get("/livraisons/"+ id)
        .then(({ data }) => {
          livraison.value = data.data; 
          console.log("livraison.value",livraison.value);
        })
        .catch(({ response }) => {
          error(response.data.message);
        });
    } 
    onMounted(() => {
      const id = route.params.id as string;
      getLivraison(id);
    });

    return { 
      livraison,
      getLivraison,
      format_Date,
     };
  },
});
</script>
